// extracted by mini-css-extract-plugin
export default {"gridContainer":"ProcedureList_gridContainer__GJak9"};